import {useEffect, useMemo, useRef, useState} from "react";
import "./membersModal.css";

const getMemberId = (member) => member?.user_id;

const getMemberInitials = (member) => {
    const email = member?.email || "";

    return email
        ? email.slice(0, 2).toUpperCase()
        : "?";
};

const getAvatarUrl = (member, imageUrl) => {
    const avatar = member?.avatar || member?.image || member?.photo;

    if (!avatar) return null;

    if (
        avatar.startsWith("http://") ||
        avatar.startsWith("https://") ||
        avatar.startsWith("data:")
    ) {
        return avatar;
    }

    return imageUrl + avatar;
};

export const MembersModal = ({
                                 position,
                                 boardMembers = [],
                                 selectedMembers = [],
                                 onToggleMember,
                                 onClose,
                                 buttonRef,
                                 imageUrl = "",
                             }) => {
    const modalRef = useRef(null);
    const [search, setSearch] = useState("");

    useEffect(() => {
        const handleClickOutside = (e) => {
            const clickedInsideModal = modalRef.current?.contains(e.target);
            const clickedMembersButton = buttonRef?.current?.contains(e.target);

            if (!clickedInsideModal && !clickedMembersButton) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose, buttonRef]);

    const selectedIds = useMemo(() => {
        return new Set(
            selectedMembers.map((member) => Number(getMemberId(member)))
        );
    }, [selectedMembers]);

    const filteredMembers = useMemo(() => {
        const searchValue = search.trim().toLowerCase();

        if (!searchValue) return boardMembers;

        return boardMembers.filter((member) =>
            member?.email?.toLowerCase().includes(searchValue)
        );
    }, [boardMembers, search]);

    return (
        <div
            ref={modalRef}
            className="membersModal"
            style={{
                top: position.top,
                left: position.left,
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <div className="membersModal__header">
                <h3>Members</h3>

                <button
                    type="button"
                    className="membersModal__close"
                    onClick={onClose}
                >
                    ✕
                </button>
            </div>

            <input
                className="membersModal__search"
                type="text"
                placeholder="Search members"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                autoFocus
            />

            <h4 className="membersModal__subtitle">Board members</h4>

            <div className="membersModal__list">
                {filteredMembers.length > 0 ? (
                    filteredMembers.map((member) => {
                        const memberId = getMemberId(member);
                        const avatarUrl = getAvatarUrl(member, imageUrl);
                        const isSelected = selectedIds.has(Number(memberId));

                        return (
                            <button
                                key={memberId}
                                type="button"
                                className={`membersModal__item ${
                                    isSelected
                                        ? "membersModal__item--selected"
                                        : ""
                                }`}
                                onClick={() => onToggleMember(member)}
                            >
                                <div className="membersModal__avatar">
                                    {avatarUrl ? (
                                        <img
                                            src={avatarUrl}
                                            alt={member.email}
                                        />
                                    ) : (
                                        <span>{getMemberInitials(member)}</span>
                                    )}
                                </div>

                                <span className="membersModal__name">
                                    {member.email}
                                </span>

                                {isSelected && (
                                    <span className="membersModal__check">
                                        ✓
                                    </span>
                                )}
                            </button>
                        );
                    })
                ) : (
                    <p className="membersModal__empty">No members found</p>
                )}
            </div>
        </div>
    );
};